export enum Zone {
  Homepage = 'Homepage',
  Research = 'Research',
  SRP = 'Search_Results_Page',
  VDP = 'Vehicle_Detail_Page',
}

export enum PageType {
  HomePageNewCarLanding = 'homepage_newcarlanding',
  Homepage = 'homepage',
  HomepageLanding = 'homepage_landing',
  SRP = 'srp',
  VDP = 'vdp',
  Accounts = 'accounts',
  SavedSearch = 'saved_search',
  Reviews = 'Reviews',
  Articles = 'Articles',
  News = 'News',
  Forums = 'forums',
  NewCarSearchHomePage = 'newcarsearch_homepage',
  Terms = 'terms',
  Privacy = 'privacy',
  AboutUs = 'about_us',
  Engineering = 'engineering',
  Comparisons = 'comparisons',
  Dealers = 'dealers',
  Scholarship = 'scholarship',
  Gallery = 'gallery',
}

export enum AgeType {
  Used = 'used',
  New = 'new',
  Classic = 'classic',
  NewPlus = 'newplus',
  None = 'none',
}

export enum BodyStyle {
  Wagon = 'wagon',
  Van = 'vam',
  Suv = 'suv',
  Specialty = 'specialty',
  Sedan = 'sedan',
  Pickup = 'pickup',
  Minivan = 'minivan',
  Hatchback = 'hatchback',
  Crossover = 'crossover',
  Coupe = 'coupe',
  Convertible = 'convertible',
}

export enum Category {
  Unique = 'unique',
  Sports = 'sports',
  OffRoad = 'off_road',
  Muscle = 'muscle',
  Luxury = 'luxury',
  Green = 'green',
  Family = 'family',
  Economy = 'economy',
  Classic = 'classic',
}
